import { RadioTableColDef } from "../RadioTable"
import { Tax } from "models/taxes"

export function getRadioColumns(
  t: (k: string) => string,
): RadioTableColDef<Tax>[] {
  return [
    {
      header: t("tax.usage.table.label"),
      accessor: "label",
    },
    {
      header: t("tax.usage.table.erpcode"),
      accessor: "erpCode",
    },
    {
      header: t("tax.usage.table.percentage"),
      render: (props) => {
        return props.amount !== undefined && props.amount !== null
          ? `${props.amount}%`
          : ""
      },
    },
  ]
}
